import { BookingKitTableColumns } from "@bonliva-crm/shared";
import { useMemo } from "react";
import locale from "@bonliva-crm/locale";

const defaultColumns: BookingKitTableColumns[] = Object.values(BookingKitTableColumns);

export function useColumnNameSelector() {
  const columnNameSelector = useMemo(() => {
    return {
      localStorageName: "kitSearchColumns",
      defaultColumns: defaultColumns.map((value) => ({
        label: locale.kitTableColumnType[value],
        value: value
      }))
    };
  }, []);

  return columnNameSelector;
}
